<template>
  <gallery-thumbnail-overlay background-color="rgba(255, 255, 255, 0.8)">
    <div class="loading-overlay-container">
      <div style="padding: 8px">
        <v-progress-circular
          color="primary"
          size="28"
          width="3"
          indeterminate
        />
      </div>
    </div>
  </gallery-thumbnail-overlay>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import GalleryThumbnailOverlay from "features/gallery/thumbnail/GalleryThumbnailOverlay.vue"
import TextBody from "components/UI/TextBody.vue"

export default defineComponent({
  name: "GalleryThumbnailLoadingOverlay",
  components: { TextBody, GalleryThumbnailOverlay },
})
</script>

<style scoped>
.loading-overlay-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  height: 100%;
}
</style>
